export default __webpack_public_path__ + "static/media/IconConvertToExcel.32c2af3f.png";